// create a colored div for each subject

import axiosConfig from "../axios/config";
import {useEffect, useState} from "react";
import {Box, Card, CardContent, CardActions, Checkbox, Grow} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
// import { styled } from '@mui/material/styles';
import _ from 'lodash';


import './NavTilesWheel.css'

const NavTilesWheel = (props) => {

    let {parentID, colors, use} = props;

    const [subjects, setSubjects] = useState([{}]);
    const [parentSubject, setParentSubject] = useState([{}]);
    const [tileColors, setTileColors] = useState([]);

    // retrieve subjects from AJAX call
    useEffect(() => {
        async function getData() {
            try {
                console.log("parentID navtiles: ", parentID);
                const response = await axiosConfig.get("/wp-json/lhstk/v1/visualnav/");
                
                let subjects = response.data.filter(subject => subject.parent == parentID); 
                let parent = response.data.find(subject => subject.term_id == parentID); 
                if(subjects.length == 0) {subjects = response.data.filter(subject => subject.term_id == parentID)}; // in case of technology and learning communities
                setParentSubject(parent);
                setSubjects(subjects);
                setTileColors(colors[[parent.slug]]);
                console.log("colors: ", colors[[parent.slug]]);
            } catch (error) {
                console.log('oups! something went wrong'+error);
            }          
        }

        getData();
    }, [parentID])

    function titleCase(str) {
        return str.toLowerCase().split(' ').map(function(word) {
          return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            {subjects.length > 0 &&
                <Grid container spacing={2} className="nav-tiles-wheel" alignItems="stretch">        
                    <Grid item xs={12} >
                        <h4>{parentSubject.description}</h4>
                    </Grid>
                    {subjects.map((subject, index) => (
                        <Grow in={true} timeout={100*index}>
                            <Grid 
                                item 
                                xs={12} sm={12} md={6} lg={4} xl={4}
                                className="nav-tiles-wheel__tile" 
                                alignItems="stretch"
                                sx={{cursor: "pointer"}}                    
                            > 
                            {/* {colors = colors[[parentSubject.slug]]}
                            {console.log("colors: ", colors)} */}
                                <Card 
                                    className="nav-tiles-wheel__tile__card"
                                    sx ={{
                                        backgroundColor: tileColors ? tileColors[index] : "#3cbeb1", 
                                        height: "100%",
                                        borderRadius: 0,
                                        cursor: "pointer",
                                    }}
                                    onClick={use == "search" ? (() => window.location.href = toolkitData.root_url + "/subject/" + subject.slug) : null}
                                >
                                    <CardContent sx={{padding: "8px"}} >
                                        <h6>{subject.name}</h6>
                                        {/* titleCase(subject.name) */}
                                        <p>{subject.description}</p>
                                    </CardContent>
                                    {use == "submit" && <CardActions sx={{padding: "8px"}} >
                                        <Checkbox
                                            id={`usp-taxonomy-${subject.taxonomy}${subject.term_id}`}
                                            name={`usp-taxonomy-${subject.taxonomy}${subject.term_id}`}
                                            value={subject.term_id}
                                        />
                                    </CardActions>}
                                </Card>
                            </Grid>
                        </Grow>
                    ))
                    }
                </Grid>
            }
        </Box>
    );
}

export default NavTilesWheel;



